import moment from 'moment-mini'

moment.parseTwoDigitYear = function(yearString) {
  if (parseInt(yearString) > +moment().format('YY')) {
    return parseInt(yearString) + 1900
  } else {
    return parseInt(yearString) + 2000
  }
}

export const validateExpirationDate = (value: any): boolean => {
  let startDate = moment()
  const datePattern = 'DD.MM.YYYY'
  return moment(value, datePattern, true).isValid() && moment(value, datePattern, true).isAfter(startDate)
}

export const validateBirthDate = (value: any): boolean => {
  let startDate = '01.01.1900'
  let endDate = moment()
  const datePattern = 'DD.MM.YYYY'
  return (
    moment(value, datePattern, true).isValid() &&
    moment(value, datePattern, true).isBetween(moment(startDate, datePattern), endDate)
  )
}

export const validateShortBirthDate = (value: string): boolean => {
  const datePattern = 'DD.MM.YY'
  const startDate = moment().subtract(100, 'years')
  const endDate = moment().startOf('year')
  return moment(value, datePattern).isValid() && moment(value, datePattern).isBetween(startDate, endDate)
}

export const composeDOBYear2To4Digits = (date: string) => {
  const oldDatePattern = 'DD.MM.YY'
  const newDatePattern = 'DD.MM.YYYY'
  return moment(date, oldDatePattern).format(newDatePattern)
}

export const validateLength = (value: string, max: number): boolean => {
  return ((value && String(value).match(/[\d+.]/g)) || []).length === max
}

export const processDateInput = (input: HTMLInputElement, key: string, start: number, val: string, max: number) => {
  if (!((+key >= 0 && +key <= 9) || key === '←') || key === ' ') {
    return ''
  }
  let newValue, cursor

  const arrayVal = val.split('')
  if (key === '←') {
    if (start > 0) {
      if (start === 3 || start === 6) {
        start--
      }
      arrayVal[start - 1] = ' '
      newValue = arrayVal.join('')
      input.value = newValue
      cursor = start - 1
      if (cursor === 3 || cursor === 6) {
        cursor--
      }
    } else {
      cursor = 0
      input.value = val
    }
  } else {
    if (start < max) {
      if (start === 2 || start === 5) {
        start++
      }
      arrayVal[start] = key
      newValue = arrayVal.join('')
      input.value = newValue

      cursor = start + 1
      if (cursor === 2 || cursor === 5) {
        cursor++
      }
    } else {
      cursor = max
      input.value = val
    }
  }
  input.focus()
  input.setSelectionRange(cursor, cursor)
}

export const validateForToday = (value: string): boolean => {
  const datePattern = 'DD.MM.YY'
  const startDate = moment().startOf('year')
  return moment(value, datePattern).isValid() && moment(value, datePattern).isBefore(startDate)
}

export const getMobileFormattedDate = (input: HTMLInputElement, value: string, maxDateLength: number): {value: string, cursorPosition: number} | null => {
  const fillSymbol = ' '
  const delimiter = '.'

  let start = input.selectionStart || 0

  const key = value[start - 1]
  const dateLength = value.length
  
  
  if (((dateLength === maxDateLength + 1) || dateLength === 1) && !(+key >= 0 && +key <= 9)) {
    return null
  }
  
  let newValue = ''
  let cursor = 0

  if (dateLength === 1) {
    newValue = key + `${fillSymbol}${delimiter}${fillSymbol}${fillSymbol}${delimiter}${fillSymbol}${fillSymbol}`
    if (maxDateLength === 10) {
      newValue += `${fillSymbol}${fillSymbol}`
    }
    cursor = 1
  }

  // user add a digit
  if (dateLength === maxDateLength + 1) {
    if (start <= maxDateLength) {
      if (start === 3 || start === 6) {
        newValue = value.substring(0, start - 1) + value.substring(start, start + 1) + key + value.substring(start + 2)
        cursor = start + 1
      } else {
        newValue = value.substring(0, start) + value.substring(start + 1)
        cursor = start
      }
    } else {
      cursor = maxDateLength
      newValue = value.substring(0, start - 1)
    }
  }
  
  // user remove a digit
  if (dateLength === maxDateLength - 1) {
      if (start === 2 || start === 5) {
        newValue = value.substring(0, start - 1) + `${fillSymbol}${delimiter}` + value.substring(start)
        cursor = start - 1
      } else if (value.trim() === `${delimiter}${fillSymbol}${fillSymbol}${delimiter}` ) {
        newValue = ''
        cursor = 0
      } else if (start >= 0) {
        newValue = value.substring(0, start) + `${fillSymbol}` + value.substring(start)
        cursor = start
      }
  }

  return {value: newValue, cursorPosition: cursor}
}